import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'

Vue.use(Router)

const originalPush = Router.prototype.push
// 修改原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default new Router({
  routes: [{
    path: '/', redirect: '/home'
  }, {
    path: '/home', name: 'home', meta: {
      title: '首页', hideInMenu: true
    }, component: () => import('@/view/home/home.vue')
  }, {
    path: '/matchMessage', name: 'matchMessage', meta: {
      title: '竞赛介绍', hideInMenu: true
    }, component: () => import('@/view/matchMessage/matchMessage.vue')
  }, {
    path: '/news', name: 'news', meta: {
      title: '新闻动态', hideInMenu: true
    }, component: () => import('@/view/home/news.vue')
  }, {
    path: '/newsDetail', name: 'newsDetail', meta: {
      title: '新闻动态详情', hideInMenu: true
    }, component: () => import('@/view/home/newsDetail.vue')
  }, {
    path: '/matchMessageDetail', name: 'matchMessageDetail', meta: {
      title: '竞赛介绍详情', hideInMenu: true
    }, component: () => import('@/view/matchMessage/matchMessageDetail.vue')
  }, {
    path: '/matchClass', name: 'matchClass', meta: {
      title: '竞赛课题', hideInMenu: true
    }, component: () => import('@/view/matchMessage/matchClass.vue')
  }, {
    path: '/matchClassDetail', name: 'matchClassDetail', meta: {
      title: '竞赛课题详情', hideInMenu: true
    }, component: () => import('@/view/matchMessage/matchClassDetail.vue')
  }, {
    path: '/resultDisplay', name: 'resultDisplay', meta: {
      title: '获奖名单', hideInMenu: true
    }, component: () => import('@/view/matchMessage/resultDisplay.vue')
  }, {
    path: '/resultDisplayDetail', name: 'resultDisplayDetail', meta: {
      title: '获奖名单详情', hideInMenu: true
    }, component: () => import('@/view/matchMessage/resultDisplayDetail.vue')
  }, {
    path: '/person', name: 'person', meta: {
      title: '个人中心', hideInMenu: true
    }, component: () => import('@/view/person/person.vue')
  }, {
    path: '/internetApply', name: 'internetApply', meta: {
      title: '网上报名', hideInMenu: true
    }, component: () => import('@/view/internetApply/internetApply.vue')
  }, {
    path: '/apply', name: 'apply', meta: {
      title: '网上报名', hideInMenu: true
    }, component: () => import('@/view/internetApply/apply.vue')
  }, {
    path: '/workSubmit', name: 'workSubmit', meta: {
      title: '作品递交', hideInMenu: true
    }, component: () => import('@/view/internetApply/workSubmit.vue')
  }, {
    path: '/applyDetail', name: 'applyDetail', meta: {
      title: '报名须知详情', hideInMenu: true
    }, component: () => import('@/view/internetApply/applyDetail.vue')
  }, {
    path: '/applyInstructions', name: 'applyInstructions', meta: {
      title: '报名须知', hideInMenu: true
    }, component: () => import('@/view/internetApply/applyInstructions.vue')
  }, {
    path: '/exam', name: 'exam', meta: {
      title: '在线考试', hideInMenu: true
    }, component: () => import('@/view/internetApply/exam.vue')
  }, {
    path: '/joinExam', name: 'joinExam', meta: {
      title: '在线考试', hideInMenu: true
    }, component: () => import('@/view/internetApply/joinExam.vue')
  }, {
    path: '/noticeAnnouncement', name: 'noticeAnnouncement', meta: {
      title: '通知公告', hideInMenu: true
    }, component: () => import('@/view/noticeAnnouncement/noticeAnnouncement.vue')
  }, {
    path: '/noticeDetail', name: 'noticeDetail', meta: {
      title: '通知公告详情', hideInMenu: true
    }, component: () => import('@/view/noticeAnnouncement/noticeDetail.vue')
  }, {
    path: '/displayWorks', name: 'displayWorks', meta: {
      title: '作品展示', hideInMenu: true
    }, component: () => import('@/view/displayWorks/displayWorks.vue')
  }, {
    path: '/workDetail', name: 'workDetail', meta: {
      title: '作品展示详情', hideInMenu: true
    }, component: () => import('@/view/displayWorks/workDetail.vue')
  }, {
    path: '/previousSessions', name: 'previousSessions', meta: {
      title: '往届回顾', hideInMenu: true
    }, component: () => import('@/view/previousSessions/previousSessions.vue')
  }, {
    path: '/commonProblem', name: 'commonProblem', meta: {
      title: '常见问题', hideInMenu: true
    }, component: () => import('@/view/commonProblem/commonProblem.vue')
  }, {
    path: '/register', name: 'register', meta: {
      title: '注册', hideInMenu: true
    }, component: () => import('@/view/home/register.vue')
  }, {
    path: '/paperDetail', name: 'paperDetail', meta: {
      title: '批改', hideInMenu: true
    }, component: () => import('@/view/person/judgesCenter/paperDetail.vue')
  }, {
    path: '/association', name: 'association', meta: {
      title: '联席会', hideInMenu: true
    }, component: () => import('@/view/association/association.vue')
  }, {
    path: '/associationDetail', name: 'associationDetail', meta: {
      title: '联席会详情', hideInMenu: true
    }, component: () => import('@/view/association/associationDetail.vue')
  }, {
    path: '/download', name: 'download', meta: {
      title: '资源下载详情', hideInMenu: true
    }, component: () => import('@/view/internetApply/download.vue')
  }, {
    path: '/downloadPage', name: 'downloadPage', meta: {
      title: '资源下载', hideInMenu: true
    }, component: () => import('@/view/internetApply/downloadPage.vue')
  }, // 学生个人中心
  {
    path: '/studentCenter',
    name: '学生个人中心',
    component: () => import('@/view/person/studentCenter/index.vue'),
    redirect: '/studentCenter/message',
    children: [{
      path: 'message', name: '个人信息', component: () => import('@/view/person/studentCenter/message.vue')
    }, {
      path: 'teamMessage', name: '赛队信息', component: () => import('@/view/person/studentCenter/teamMessage.vue')
    }, {
      path: 'worksMessage', name: '作品信息', component: () => import('@/view/person/studentCenter/worksMessage.vue')
    }, {
      path: 'password', name: '密码修改', component: () => import('@/view/person/studentCenter/password.vue')
    }]
  }, // 评审个人中心
  {
    path: '/judgesCenter',
    name: '评审个人中心',
    component: () => import('@/view/person/judgesCenter/index.vue'),
    redirect: '/judgesCenter/myJudges',
    children: [{
      path: 'myJudges', name: '我的评审', component: () => import('@/view/person/judgesCenter/myJudges.vue')
    }, {
      path: 'judgesRecord', name: '评审记录', component: () => import('@/view/person/judgesCenter/judgesRecord.vue')
    }, {
      path: 'testPaper', name: '试卷批改', component: () => import('@/view/person/judgesCenter/testPaper.vue')
    }, {
      path: 'judgesword', name: '评审密码', component: () => import('@/view/person/judgesCenter/password.vue')
    }, {
      path: 'paperList', name: 'paperList', meta: {
        title: '试卷列表', hideInMenu: true
      }, component: () => import('@/view/person/judgesCenter/paperList.vue')
    },
    {
      path: 'work/:id', // 增加动态参数 :id
      name: '作品详情',
      props: true, // 开启props自动接收id
      component: () => import('@/view/person/judgesCenter/work.vue')
    }
    ]
  }]
})



// WEBPACK FOOTER //
// ./src/router/index.js